import { storages } from '@/lib/browserStorage'
import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

export function clearLocalStorage(): ApplicationState['auth'] {
	storages.local.removeItem('access_token')
	storages.local.removeItem('refresh_token')
	storages.local.removeItem('id_token')
	storages.local.removeItem('expires_at')
	storages.local.removeItem('internal_user')
	storages.local.removeItem('terms_accepted')

	return new ImmutableMap()
}
